import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData } from '../../helpers/fackBackend_Helper';

function* addMDNSwapResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/getMsisdnPoolData', data);
        if (response?.response?.Status) {
            yield put(actions.createMdnSwapRequestSuccessful(response?.response?.Message));
        } else {
            yield put(actions.createMdnSwapRequestFailed(response?.response?.Message));
        }
    } catch (error) {
        yield put(actions.createMdnSwapRequestFailed(error));
    }
}


export default function* rootSaga() {
    yield all([takeEvery(actions.CREATE_MDN_SWAP_REQUEST, addMDNSwapResponse)]);
}
